import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BusinessFollowButton from '../../../front/Businesses/Follow/FollowButton';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '100vh',
    width: '100%',
    maxWidth: 220,
    padding: '8px 10px',
    fontSize: theme.typography.pxToRem(12),
    [theme.breakpoints.up('sm')]: {
      padding: '7px 30px',
      whiteSpace: 'nowrap',
      fontSize: theme.typography.pxToRem(15),
    },
  },
}));

const FollowButton = ({ businessId, name, authenticated, following }) => {
  const classes = useStyles();
  return (
    <BusinessFollowButton
      businessId={businessId}
      businessName={name}
      isAuthenticated={authenticated}
      isFollowing={following}
      classes={{ root: classes.root }}
    >
      おてつたび先をフォロー
    </BusinessFollowButton>
  );
};

export default FollowButton;
